import React from 'react';
import { Typography, IconButton, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useModal, TitleProps } from '@lwtears/lwt-common-frontend/lib/Modal';

export const BaseModalTitle: React.FC<TitleProps> = ({ text = '' }) => {
  const [, { closeModal }] = useModal();
  const classes = useStyles();
  return (
    <>
      <DialogTitle className={`${classes.titleClass} ${classes.baseTitleClass}`}>
        <Typography variant="h3">{text}</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={closeModal}>
          <FontAwesomeIcon icon={faTimes} className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>
    </>
  );
};

const useStyles = makeStyles((theme: any) => ({
  baseTitleClass: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '8px 24px !important'
  },
  closeButton: () => ({
    margin: '-10px !important',
    padding: '10px !important',
    top: 0.5,
    color: theme.palette.black.main,
    textAlign: 'center',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'unset !important'
    }
  }),
  closeIcon: {
    fontSize: '16px !important',
    color: theme.palette.black.main,
    fontWeight: 500
  },
  titleClass: () => ({
    backgroundColor: theme.palette.primary.main
  })
}));
